<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {
    this.int()
  },
  methods: {
    async int() {
      let version = await this.$betterwe.getAppVersion().catch(() => {})
      if (version >= 98) {
        let promise1 = this.$http.getBaseApp(
          'api/v3/WeplusData/getWeplusInfoForNoVip',
          {}
        )
        let promise2 = this.$http.getBaseApp(
          'api/v3/WeplusData/getUserWeplusIdentify',
          {}
        )
        Promise.all([promise1, promise2])
          .then((arr) => {
            let [res1, res2] = arr
            res1 = res1.data
            res2 = res2.data
            if (res1.code == 200 && res2.code == 200) {
              let queState = res1.data.config.general_que_state
              let vipInfo = res2.data
              let resultRoute =
                res1.data.user_info.result_route ||
                res1.data.user_info.test_route
              let cardTypeAttr = res1.data.config.card_type_attr
              let vipTypeId = res1.data.config.vip_type_id
              this.jumpPage(
                vipInfo,
                queState,
                resultRoute,
                cardTypeAttr,
                vipTypeId
              )
            } else {
              this.$toast('接口异常错误')
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        this.$router.replace('/betterwe/vip')
      }
    },
    jumpPage(vipInfo, queState, resultRoute, cardTypeAttr, vipTypeId) {
      //新人问卷状态 : 0-已过期,1-未领取 2-已领取待使用，3-已使用',
      if (queState == 3) {
        if (vipInfo.is_old_weplus) {
          /* 用户已使用新人问卷且是老版会员 跳转vip权益页 */
          this.$router.replace('/betterwe/vip')
        } else if (vipInfo.is_weplus) {
          /* 用户已使用新人问卷且是新版会员 跳转新版vip权益页 */
          this.jumpVipDetail()
        } else {
          /* 用户已使用新人问卷且是非会员 弹窗提醒【你已完成测评，是否查看评估结果】，是则跳结果页，否则跳购买页 */
          this.$dialog
            .confirm({
              title: '提示',
              message: '你已完成测评，是否查看评估结果'
            })
            .then(() => {
              this.$router.go(-1)
              this.$betterwe.jumpRoute(resultRoute)
              //  this.$router.replace("/newcomer-questionnaire-v2/result?id=" + id);
            })
            .catch(() => {
              /* 去购买页 选中指定卡种 */
              this.jumpBuyVip(cardTypeAttr, vipTypeId)
            })
        }
      } else if (queState == 2) {
        if (vipInfo.is_old_weplus) {
          /* 用户已领取待使用且是老版会员 跳老会员权益页*/
          this.$router.replace('/betterwe/vip')
        } else {
          /* 去填写问卷 */
          this.$router.go(-1)
          this.$betterwe.jumpRoute(resultRoute)
        }
      } else {
        if (vipInfo.is_old_weplus) {
          /* 用户未领取新人问卷且是老版会员 跳转vip权益页 */
          this.$router.replace('/betterwe/vip')
        } else {
          this.receiveQue()
        }
      }
    },
    /* 领取新人问卷 */
    receiveQue() {
      this.$http
        .getBaseApp('/member/AppCamp/receiveComerQue', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.getVipData()
          } else {
            this.$toast(res.msg)
          }
        })
    },
    getVipData() {
      this.$http
        .getBaseApp('api/v3/WeplusData/getWeplusInfoForNoVip', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$router.go(-1)
            this.$betterwe.jumpRoute(res.data.user_info.test_route)
          }
        })
    },
    /* 去大会员权益页 */
    jumpVipDetail() {
      this.$router.go(-1)
      this.$betterwe.onAppPageUrlRoute('/vipUserEquity')
    },
    /* 去购买vip页 */
    jumpBuyVip(cardTypeAttr, vipTypeId) {
      this.$router.go(-1)
      this.$betterwe.vipHomePage({
        card_type_attr: cardTypeAttr,
        vip_type_id: vipTypeId
      })
    }
  }
}
</script>
